'use strict';

export default {
    trigger(type, entity, quantity) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: '/api/loop54/events',
                headers: {
                    'Accept': 'application/json'
                },
                data: {
                    type: type,
                    entity: entity,
                    quantity: quantity,
                }
            })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Services/Loop54.js